import pdfMake, { userMark, setMyConfig, makeTableContent } from "../utils/pdf";

function pdfEndosados(payload) {
  const columnsEndosados = [
    {
      key: "codigo",
      label: "Cód.",
      width: "auto"
    },
    "fecha:wauto",
    {
      key: "horaInicio",
      label: "Hora I. / R.",
      width: 25,
      depend: ["horaRecojo"],
      content: function(row) {
        let horaInicio = (row.horaInicio || "").trim();
        let horaRecojo = (row.horaRecojo || "").trim();

        let tempContent = "";
        if (horaInicio) tempContent += "I: " + horaInicio;
        if (horaRecojo)
          tempContent += `${horaInicio ? "\n" : ""}R: ${horaRecojo}`;

        return tempContent;
      }
    },
    {
      key: "servicio",
      label: "Servicio",
      width: "*",
      depend: ["origen", "destino"],
      content: function(row) {
        let servicio = (row.servicio || "").trim();
        let origen = (row.origen || "").trim();
        let destino = (row.destino || "").trim();

        let tempContent = "";
        if (servicio) tempContent += servicio;
        if (origen) tempContent += `${tempContent ? "\n" : ""}O: ${origen}`;
        if (destino) tempContent += `${tempContent ? "\n" : ""}D: ${destino}`;

        return tempContent;
      }
    },
    {
      key: "serviciotipo",
      label: "Tipo",
      width: "auto"
    },
    "pasajero:w*",
    {
      key: "nroAdultos",
      label: "PAX",
      width: 13
    },
    {
      key: "nroNinos",
      label: "CHD",
      width: 13
    },
    "hotel:w40",
    "agencia:w*",
    {
      key: "trenIn",
      label: "Tren In / Out",
      width: 50,
      depend: ["trenOut"],
      content: function(row) {
        let trenIn = (row.trenIn || "").trim();
        let trenOut = (row.trenOut || "").trim();

        let tempContent = "";
        if (trenIn) tempContent += "I: " + trenIn;
        if (trenOut) tempContent += `${trenIn ? "\n" : ""}O: ${trenOut}`;

        return tempContent;
      }
    },
    {
      key: "vehiculo",
      label: "Móvil / Conductor",
      width: 50,
      depend: ["conductor"],
      content: function(row) {
        let vehiculo = (row.vehiculo || "").trim();
        let conductor = (row.conductor || "").trim();
        let tempContent = "";
        if (vehiculo) tempContent += vehiculo;
        if (conductor) tempContent += `${vehiculo ? "\n" : ""}${conductor}`;

        return tempContent;
      }
    },
    {
      key: "guia",
      label: "Guía",
      width: 50
    },
    "transfer:w50",
    {
      key: "idioma",
      label: "Id.",
      width: 13
    },
    {
      key: "observaciones",
      label: "Observaciones:",
      depend: ["horaTicket", "horaHuayna", "hotelOvernight", "restaurante"],
      fit: true,
      condition(row) {
        return (
          String(row.observaciones || "").trim() ||
          String(row.horaTicket || "").trim() ||
          String(row.horaHuayna || "").trim() ||
          String(row.hotelOvernight || "").trim() ||
          String(row.restaurante || "").trim()
        );
      },
      content(row) {
        let observaciones = (row.observaciones || "").trim();
        let horaTicket = (row.horaTicket || "").trim();
        let horaHuayna = (row.horaHuayna || "").trim();
        let hotelOvernight = (row.hotelOvernight || "").trim();
        let restaurante = (row.restaurante || "").trim();

        let tempContent = "";
        if (observaciones) tempContent += observaciones + " / ";

        let fields = [];

        if (horaTicket) fields.push(`HT: ${horaTicket}`);
        if (horaHuayna) fields.push(`HHP: ${horaHuayna}`);
        if (hotelOvernight) fields.push(`ON: ${hotelOvernight}`);
        if (restaurante) fields.push(`L: ${restaurante}`);

        if (fields.length) tempContent += fields.join(" / ");

        return tempContent;
      }
    },
    "file:w30"
  ];

  const table = makeTableContent([...payload.endoses], columnsEndosados, true);
  const title = payload.reporte
    ? "Reporte Endoses por fecha"
    : "Reporte Endoses";

  pdfMake
    .createPdf({
      info: {
        title: title
      },
      content: [
        {
          text: title,
          style: "h1"
        },
        {
          columns: [
            {
              text: `Agencia: ${payload.agencia}`,
              width: "auto"
            },
            {
              text: `Servicio: ${payload.servicio}`,
              width: "auto"
            },
            {
              text: `Fecha${payload?.reporte ? " Inicio" : ""}: ${
                payload.fechaInicio
              }`,
              width: "auto"
            },
            payload?.reporte
              ? {
                  text: `Fecha Fin: ${payload.fechaFin}`,
                  width: "auto"
                }
              : {
                  text: `Pasajero: ${payload.pasajero}`,
                  width: "auto"
                }
          ]
        },
        {
          text: "",
          margin: [0, 0, 0, 2.5]
        },
        table,
        ...userMark(payload.userMark, payload.dateMark)
      ],
      ...setMyConfig()
    })
    .print();
}

export default pdfEndosados;
